import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import './index.css'
import Footer from './components/Footer'
import Home from './components/Home'
import SinlgeBlogsPage from './components/SinlgeBlogsPage'

const App = () => {
  return (
    <Router>
      <Switch>
        <Route path="/foo/:id">
          <SinlgeBlogsPage />
        </Route>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
      <Footer />
    </Router>
  );
};

export default App;
